export const ACTIONS_MACHINE_MINE_PLAN = {
  INVALIDATE: 'MACHINE_MINE_PLAN_INVALIDATE',
  RECEIVE: 'MACHINE_MINE_PLAN_RECEIVE',
  DELETE: 'MACHINE_MINE_PLAN_DELETE',
  UPDATE: 'MACHINE_MINE_PLAN_UPDATE',
};

const machineMinePlanConstants = {};

export default machineMinePlanConstants;
